export default {
    CanMovePayment: 'CanMovePayment',
    CanEditPayment: 'CanEditPayment',
    CanDeletePayment: 'CanDeletePayment',
    CanCancelPayment: 'CanCancelPayment',
    CanResumePayment: 'CanResumePayment',
};
